// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".contact__panel[data-v-0caf7212],.v-sheet.v-card[data-v-0caf7212]{border-radius:10px}.contact__panel[data-v-0caf7212]{background-color:#fff}.filter-userrole__input[data-v-0caf7212]{max-width:500px}[data-v-0caf7212] .switch__active .v-input__slot{margin-bottom:0}[data-v-0caf7212] .switch__active .v-messages{display:none}", ""]);
// Exports
module.exports = exports;
